import { formatDate } from 'Utils/dateUtil'
import api from 'Plugins/api'

const HTSEARCHINFO = () => {
  return {
    /**
     * 国籍
     */
    _nationality: {
      code: 'CN',
      id: '00002',
      name: '中国'
    },
    /**
     * 国际入住人条件
     */
    _conditions: {
      roomCount: '1',
      children: [{
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }, {
        age: '1',
        show: false
      }], // 儿童年龄[]
      adultPopulation: '1',
      childrenNumber: 0,
      model: {
        adultPopulation: '1', // 成人人数
        childrenNumber: 0, // 儿童人数
        ageItems: [] // 儿童年龄[]
      }
    },
    /**
     * 国内 国际
     */
    _international: 0,
    /**
     * 出差申请单数据集
     */
    _ccsqd: {},
    /**
     * 具体的行程
     */
    _voyage: {},
    _min_date: '',
    _max_date: '',
    /**
     * 是否走出差申请人模式 预定义节点对象 _ccsqPattern
     * -> checked true: 出差申请单模式 false: 非出差申请单模式
     */
    _ccsqPattern: {
      checked: false, // 出差申请单模式
      fyys: 0, // 费用预算
      fjs: 0, // 房间数
      obj: {} // 出差申请单回显对象
    },
    /**
     * 酒店差旅政策详情查询
     * _policy匹配了[当前登录用户/出行人/多个出行人按差标等级最低标准]
     */
    sfpf: false,
    _policy: {
      clzcJe: '', // 差旅单间夜金额
      totalClzcJe: '', // 差旅单间夜金额
      clzcBhFwf: '0', // 差旅金额是否包含服务费0不包含1包含
      gkfs: '', // 管控方式1只做提醒2不允许预订
      wjMonths: '', // 旺季月份多个用半角,分割
    }, // 酒店差旅价格标准
    _checkInDate: formatDate(new Date()), // 入住日期
    _checkOutDate: formatDate(new Date(), 1), // 离店日期
    _days: 1, // 入住-离店的天数=
    _roomNum: 1,
    _province: '',
    _city: '',
    _cityName: '',
    _district: '',
    _street: '',
    _keywords: '',
    _cityId: '',
    _cityIdInt: '',
    _cityNameInt: '',
    brandIds: '', // 品牌id，多个以逗号隔开
    zcfs: '', // 早餐份数
    roomBedType: '', // 床型
    businessZone: '', // 商圈id，searchType=2时，必传
    businessZoneName: '', // (string, optional): 商圈名称 ,
    checkInDate: formatDate(new Date()).date, // 入住日期：yyyy-mm-dd
    checkOutDate: formatDate(new Date(), 1).date, // 离店日期：yyyy-mm-dd
    cityId: '', // 城市id
    corpId: '', // 企业id
    distance: 8, // 离指定经纬度距离（单位：公里）。默认3公里 中宏越需求：调整为8KM
    district: '', // 行政区id，searchType=1时，必传
    districtName: '', // (string, optional): 行政区名称 ,
    exclude: 0, // 为1 并且 jdids不为空，表示排除这些jdids的其他酒店；默认为0
    jdType: 1, // 酒店类型，0全部，1是可售酒店,2是签约,10是热门。默认1
    jdids: '', // 酒店id，多个酒店id用英文逗号隔开
    keywords: '', // 酒店名称、或酒店地址中包含的关键字
    lat: '', // 百度纬度，searchType=3时，必传
    lon: '', // 百度经度，searchType=3时，必传
    onlySign: 0, // 是否仅查查询sign 1为是
    priceSourceType: null, // 上游协议价格来源 2线上协议
    priceRange: '', // 价格范围：不传代表不限；范围以-隔开；如果是150元以下，传0-150；如果是800元以上，传800-999999
    propertyIds: '', // 服务设施id，多个以逗号隔开
    facilitieNames: '', // 服务设施名称，多个以逗号隔开
    searchType: 0, // 查询类型，1 按行政区；2 按商圈；3 按经纬度；默认 0
    sort: 12, // 12按评分降序；21为星级升序，22为星级降序；31为价格升序，32为价格降序；41 距离升序。当searchType=3时，默认为41，其他情况默认 12
    starRate: '', // 挂牌星级：不限就不传；二星级以下,传2；三星传3；以此类推,多个以英文逗号隔开
    themes: '', // 酒店主题，多个用逗号隔开
    tripType: 1, // 差旅类型,1是因公,2是因私 因公时必填
    singaZhid: '', // singa账号id
    platZhid: '', // 平台账号ID
    pageNum: 1,
    count: 20,
    path: '/ht/htOrder',
    backPath: '/ht/htQuery',
    /**
     * 备注页面的备注信息 提交询价操作会清空该值
     */
    customRemark: '',
    /**
		 * 差旅违背信息
		 */
    _violate: {},
    /**
		 * 存储列表数据列
		 */
    _listData: [],
    /**
		 * 临时存储_violation.reasonCode与_violation.reasonDesc
		 */
    _reason: {
      reasonCode: '',
      reasonDesc: ''
    }
  }
}

const ht = {
  namespaced: true,

  state: {//state就是Vuex中的公共的状态, 我是将state看作是所有组件的data, 用于保存所有组件的公共数据.
    htSearchInfo: HTSEARCHINFO(),
    travelerList: [],
    orderDetails: {
      /*
      * address (string, optional): 地址 ,
      * airportPickUpService (string, optional): 接机服务 ,
      * baiduLat (number, optional): 百度纬度 ,
      * baiduLon (number, optional): 百度经度 ,
      * bookingSuccessScore (string, optional): 预订成功率。百分比，格式是98%。 ,
      * brandId (integer, optional): 品牌编号 ,
      * brandName (string, optional): 品牌名称 ,
      * businessZone (string, optional): 主商圈,编码，请在GEO数据中对应 ,
      * businessZone2 (string, optional): 附属商圈编码 ,
      * businessZone2Name (string, optional): 附属商圈名称 ,
      * businessZonename (string, optional): 主商圈名称 ,
      * canSell (integer, optional): 是否可销售。1可销售；0不可销售 ,
      * category (string, optional): 艺龙推荐星级 ,
      * cityId (string, optional): 主城市id ,
      * cityId2 (string, optional): 关联城市 ,
      * cityId2Name (string, optional): 关联城市名称 ,
      * cityIdName (string, optional): 城市名称 ,
      * complaintScore (string, optional): 用户投诉率。百分比，格式是1%。 ,
      * createdate (string, optional): 创建时间/新增酒店 ,
      * creditCards (string, optional): 酒店支持的信用卡,信用卡中文名字 ,
      * description (string, optional): 描述 ,
      * district (string, optional): 行政区,编码，请在GEO数据中对应 ,
      * districtname (string, optional): 行政区名称 ,
      * establishmentDate (string, optional): 开业时间 ,
      * facilities (string, optional): 服务设施 ,
      * fax (string, optional): 传真 ,
      * features (string, optional): 特色信息 ,
      * generalAmenities (string, optional): 酒店基础设施 ,
      * googleLat (number, optional): 谷歌纬度 ,
      * googleLon (number, optional): 谷歌经度 ,
      * groupId (integer, optional): 集团编号 ,
      * hotelStatus (integer, optional): 酒店状态。1: 开启；0: 已经关闭。 ,
      * img (string, optional): 酒店主图 ,
      * instantConfirmScore (string, optional): 及时确认率。百分比，格式是96%。 ,
      * international (integer, optional): 区域分类（0国内1港澳台2国际） ,
      * introEditor (string, optional): 介绍信息 ,
      * jden (string, optional): 英文名称 ,
      * jdid (integer, optional): 酒店id ,
      * jdmc (string, optional): 酒店名称 ,
      * lastBookTime (string, optional): 最后预订时间 ,
      * lastUpdateTime (string, optional): 最后更新时间 ,
      * nation (string, optional): 所在国家id ,
      * nationName (string, optional): 所在国家名称 ,
      * phone (string, optional): 电话 ,
      * postalCode (string, optional): 邮编 ,
      * price (number, optional): 参考最低价 ,
      * province (string, optional): 所在省份 ,
      * provinceName (string, optional): 所在省份名称 ,
      * rank (integer, optional): 推荐排序 ,
      * recreationAmenities (string, optional): 酒店休闲设施 ,
      * renovationDate (string, optional): 装修时间 ,
      * roomTotalAmount (integer, optional): 客房总数量 ,
      * score (string, optional): 酒店评分 ,
      * serviceAmenities (string, optional): 酒店服务设施 ,
      * starRate (string, optional): 挂牌星级 ,
      * surroundings (string, optional): 周边信息 ,
      * themes (string, optional): 酒店主题 ,
      * traffic (string, optional): 周边交通
      * ==扩展参数==
      * hotelRoom: []
      * ==其他自定义参数 下单使用==
      * _violation: { // 违背
      *  reasonCode: '', // 违背原因代码
      *  reasonDesc: '' // 违背原因说明
      *  violateitem: '' // 违背事项
      * },
      * _roomId: '', // 房型id,不能为空
      * _ratePlans: '' // 选定的价格计划
      */
    },
    /**
     * 接口供应商标识
     */
    interfacePlat: {},
    /**
     * 差旅标准对象
     */
    pageCtrl: {
      addCxr: '',
      isCcsqdGK: '',
      isChangeDate: '',
      isChangeDateRange: '',
      isChangeVoyage: '',
      isDefaultName: '',
      isShowCcsqd: '',
      isShowCxr: '',
      isStart: '',
      showtips: ''
    },
    /**
     * 历史记录
     */
    historicalRecord: [],
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性
    htSearchInfo: (state) => {
      return state.htSearchInfo || {}
    },
    travelerList: (state) => {
      return state.travelerList || []
    },
    orderDetails: (state) => {
      return state.orderDetails || {}
    },
    interfacePlat: (state) => {
      return state.interfacePlat || {}
    },
    pageCtrl: (state) => {
      return state.pageCtrl || {}
    },
    historicalRecord: (state) => {
      return state.historicalRecord || []
    }
  },
  mutations: { //mutaions理解为store中的methods
    htSearchInfo (state, payload) {
      Object.assign(state.htSearchInfo, payload)
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    orderDetails (state, payload) {
      state.orderDetails = payload
    },
    interfacePlat (state, payload) {
      state.interfacePlat = payload

      state.htSearchInfo.platZhid = payload.platZhid
      state.htSearchInfo.singaZhid = payload.singaZhid
    },
    pageCtrl (state, payload) {
      state.pageCtrl = payload
    },
    SET_TRAVELPOLICY (state, payload) {
      state.htSearchInfo._policy = payload
    },
    historicalRecord (state, payload) {
      state.historicalRecord = payload
    },
    CLEAR_ALL (state) {
      state.htSearchInfo = HTSEARCHINFO()
      state.travelerList = []
      state.orderDetails = {}
    },
    SET_VIOLATELIST (state, payload) {
      state.htSearchInfo._violate = {
        ...payload
      }
    },
  },
  actions: {
    /**
     * 匹配服务费
     */
    // async matchFwf ({ commit, state, dispatch }, ratePlan) {
    // 	let fwfMatchList_ = []
    // 	ratePlan.nightlyRates && ratePlan.nightlyRates.forEach(element => {
    // 		fwfMatchList_.push({
    // 			date: element.date,
    // 			salePrice: element.salePrice
    // 		})
    // 	})

    // 	api['htQuery/matchQuery']({
    // 		'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入
    // 		'roomCount': state.htSearchInfo._roomNum, // 房间数
    // 		'cplx': '10903', // 产品类型编号，对应产品枚举编号，10903：国内酒店，10910：国际酒店
    // 		'jgly': ratePlan.bussType == '1' ? '2' : ratePlan.bussType == '2' ? '3' : '1', // 价格来源， 1：平台，2：代理自签 ，3：企业自签 ,
    // 		'type': state.htSearchInfo.tripType, // 因公因私，1：公 0：私 ,
    // 		'fwfMatchList': fwfMatchList_
    // 	}).then(res => {
    // 		commit('ht/orderDetails', Object.assign({}, state.orderDetails, {
    // 			_matchQueryData: res.data
    // 		}))
    // 	})
    // },
    /**
     * 获取酒店差旅标准
     * 依然一直以state里的存储值为准
     * @param {roomItems: 酒店订单填写页的roomItems} 传房间实例进来则roomList按这些房间里的人匹配，不传则按一人一间房匹配
     */
    async getTravelPolicy ({ commit, state, dispatch }, roomItems) {
      try {
        if (!state.htSearchInfo.cityId || !state.pageCtrl.isStart) return

        let roomList = [],
          travelerList = state.travelerList,
          sfpf = state.htSearchInfo.sfpf

        // 没传房间进来   按是否拼房  拼房：两人一间  不拼房：一人一间房 算
        if (!roomItems) {
          const traverInRoomNum = sfpf ? 2 : 1 // 一间房住的人数
          let ReTravelerList = []

          for (let i = 0; i < travelerList.length; i++) {
            ReTravelerList.push([])

            for (let j = 0; j < traverInRoomNum; j++) {
              const traver = travelerList[i + j]
              if (traver) ReTravelerList[ReTravelerList.length - 1].push(traver)

              if (j === traverInRoomNum - 1) i += traverInRoomNum - 1
            }
          }

          ReTravelerList.forEach((travers, index) => {
            roomList.push({
              roomNo: index + 1,
              customerList: []
            })

            travers.forEach((traver) => {
              roomList[roomList.length - 1].customerList.push({
                empDeptid: traver.deptId,
                empId: traver.empId,
                idNo: traver.idNo,
                psgName: traver.contactsId ? traver.chName : traver.empName,
                psgPhone: traver.phoneNumber,
              })
            })
          })
        } else {
          roomItems.forEach((travers, index) => {
            let room = {
              roomNo: index + 1,
              customerList: []
            }

            travers.forEach((traver) => {
              room.customerList.push({
                empDeptid: traver.deptId,
                empId: traver.empId,
                idNo: traver.idNo,
                psgName: traver.contactsId ? traver.chName : traver.empName,
                psgPhone: traver.phoneNumber,
              })
            })

            roomList.push(room)
          })
        }

        state.htSearchInfo._roomNum = roomList.length

        const { data = {} } = await api['htQuery/travelPolicy']({
          sfpf: sfpf ? 1 : 0,
          cityId: state.htSearchInfo.cityId,
          rzrq: state.htSearchInfo.checkInDate,
          ldrq: state.htSearchInfo.checkOutDate,
          roomList: roomList,
        })

        data.totalClzcJe = data.clzcJe
        data.clzcJe = (data.totalClzcJe / state.htSearchInfo._days / (roomList.length || 1) || 0).toFixed(2)
        data.clzcJe === '0.00' && (data.clzcJe = '')

        commit('SET_TRAVELPOLICY', data)
      } catch (err) {
        throw err
      }
    },
  }
}
export default ht
